import React from "react";
import "./BuyMula.css";
import arrow from "../../../assets/Fill 152.png";

const BuyMula = () => {
  return (
    <div className="buymula__section">
      <div className="princess">
        <h2 className="buymula__section__title">
          HOW TO BUY <span> MULA TOKEN</span>
        </h2>
        <p className="buymula__section__sub__title">
          In other to make cross border transactions, you will need MULA.
          Luckily, they’re for sale on many exchanges (decentralized and
          centralized).
        </p>
        <p className="buymula__section__second__sub__title">
          You can also easily load your mula wallet with your local currency
          using mobile money and visa cards then convert your local currency to
          Mula and back.
        </p>
      </div>
      <div className="arrow">
        <img src={arrow} alt="" />
      </div>
    </div>
  );
};

export default BuyMula;
